<template>
  <div class="front_page">
    <el-container>
      <el-main>
        <h2 class="page_title">Andy's Portfolio Archive</h2>
        <div class="form_container">
          <el-form ref="form" :rules="rules" :model="form" required>
            <el-form-item prop="password">
              <el-input v-model="form.password" placeholder="Input Password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="onSubmit('form')">Enter</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";

export default {
  name: "FrontPage",
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value != "321") {
        return callback(new Error("Password incorrect"));
      } else {
        callback();
      }
    };
    return {
      form: {
        password: "",
      },
      rules: {
        password: [
          {
            required: true,
            message: "Please input password",
            trigger: "blur",
          },
          { validator: validatePassword, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["loginPassword"]),
  },
  watch: {
    loginPassword: function (newVal) {
      if (newVal) {
        this.$router.push("/list");
      }
    },
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("actionSetPassword", this.form.password);
        } else {
          console.log("error submiting password");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.front_page {
  height: 100vh;
  .page_title {
    color: #67c23a;
    font-size: 30px;
    margin-top: 80px;
  }

  .form_container {
    background-color: rgba(0, 0, 0, 0.03);
    box-shadow: inset 1px 1px 3px 0px rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    max-width: 400px;
    margin: 40px auto 0 auto;
    border: 1px solid #f3f3f3;
    padding: 20px;
  }
}
</style>
